import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { getApiUiUrl } from "@/shared/lib/apiDocsUrl";

const ApiDocsRedirect: React.FunctionComponent = () => {
  useEffect(() => {
    window.location.replace(getApiUiUrl());
  }, []);

  return null;
};

export const Route = createFileRoute("/api-docs")({
  component: ApiDocsRedirect,
});
